<template>
  <el-dialog
    :title="$t('payFeeQrcode.edit.title')"
    :visible.sync="visible"
    width="50%"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item
        :label="$t('payFeeQrcode.form.qrcodeName')"
        prop="qrcodeName"
      >
        <el-input
          v-model="form.qrcodeName"
          :placeholder="$t('payFeeQrcode.placeholder.qrcodeName')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('payFeeQrcode.form.queryWay')"
        prop="queryWay"
      >
        <el-select
          v-model="form.queryWay"
          :placeholder="$t('payFeeQrcode.placeholder.queryWay')"
          style="width:100%"
        >
          <el-option
            v-for="item in queryWayOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('payFeeQrcode.form.smsValidate')"
        prop="smsValidate"
      >
        <el-select
          v-model="form.smsValidate"
          :placeholder="$t('payFeeQrcode.placeholder.smsValidate')"
          style="width:100%"
        >
          <el-option
            :label="$t('common.yes')"
            value="ON"
          />
          <el-option
            :label="$t('common.no')"
            value="OFF"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('payFeeQrcode.form.customFee')"
        prop="customFee"
      >
        <el-select
          v-model="form.customFee"
          :placeholder="$t('payFeeQrcode.placeholder.customFee')"
          style="width:100%"
        >
          <el-option
            :label="$t('common.yes')"
            value="ON"
          />
          <el-option
            :label="$t('common.no')"
            value="OFF"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('payFeeQrcode.form.preFee')"
        prop="preFee"
      >
        <el-select
          v-model="form.preFee"
          :placeholder="$t('payFeeQrcode.placeholder.preFee')"
          style="width:100%"
        >
          <el-option
            :label="$t('common.yes')"
            value="ON"
          />
          <el-option
            :label="$t('common.no')"
            value="OFF"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('payFeeQrcode.form.content')"
        prop="content"
      >
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="3"
          :placeholder="$t('payFeeQrcode.placeholder.content')"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
      >
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updatePayFeeQrcode } from '@/api/fee/payFeeQrcodeApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'EditPayFeeQrcode',
  data() {
    return {
      visible: false,
      form: {
        pfqId: '',
        qrcodeName: '',
        queryWay: '',
        smsValidate: '',
        customFee: '',
        preFee: '',
        content: '',
        state: '',
        feeType: '',
        communityId: ''
      },
      rules: {
        qrcodeName: [
          { required: true, message: this.$t('payFeeQrcode.rules.qrcodeName'), trigger: 'blur' },
          { max: 128, message: this.$t('payFeeQrcode.rules.qrcodeNameMax'), trigger: 'blur' }
        ],
        queryWay: [
          { required: true, message: this.$t('payFeeQrcode.rules.queryWay'), trigger: 'change' }
        ],
        smsValidate: [
          { required: true, message: this.$t('payFeeQrcode.rules.smsValidate'), trigger: 'change' }
        ],
        customFee: [
          { required: true, message: this.$t('payFeeQrcode.rules.customFee'), trigger: 'change' }
        ],
        preFee: [
          { required: true, message: this.$t('payFeeQrcode.rules.preFee'), trigger: 'change' }
        ],
        content: [
          { required: true, message: this.$t('payFeeQrcode.rules.content'), trigger: 'blur' },
          { max: 512, message: this.$t('payFeeQrcode.rules.contentMax'), trigger: 'blur' }
        ],
        pfqId: [
          { required: true, message: this.$t('payFeeQrcode.rules.pfqId'), trigger: 'blur' }
        ]
      },
      queryWayOptions: [
        { value: '1001', label: this.$t('payFeeQrcode.queryWay.byPhone') },
        { value: '2002', label: this.$t('payFeeQrcode.queryWay.byHouse') },
        { value: '3003', label: this.$t('payFeeQrcode.queryWay.byBoth') }
      ]
    }
  },
  methods: {
    open(data) {
      this.visible = true
      // 深拷贝数据，避免引用问题
      this.form = {
        pfqId: data.pfqId || '',
        qrcodeName: data.qrcodeName || '',
        queryWay: data.queryWay || '',
        smsValidate: data.smsValidate || '',
        customFee: data.customFee || '',
        preFee: data.preFee || '',
        content: data.content || '',
        state: data.state || '',
        feeType: data.feeType || '',
        communityId: getCommunityId()
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleClose() {
      // 重置表单字段，但保留 visible 状态由 dialog 控制
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      // 重置表单数据到初始状态
      this.form = {
        pfqId: '',
        qrcodeName: '',
        queryWay: '',
        smsValidate: '',
        customFee: '',
        preFee: '',
        content: '',
        state: '',
        feeType: '',
        communityId: ''
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await updatePayFeeQrcode(this.form)
            this.$message.success(this.$t('payFeeQrcode.message.editSuccess'))
            this.visible = false
            this.$emit('success')
          } catch (error) {
            this.$message.error(error.message || this.$t('payFeeQrcode.message.editFailed'))
          }
        }
      })
    }
  }
}
</script>